// const getHighlightedText = (text, highlight) => {

//     if (!text) return
//     if (!highlight) return text

//     // Split on highlight term and include term into parts, ignore case
//     const parts = `${text}`.split(new RegExp(`(${highlight})`, 'gi'));
//     return <span> {parts.map((part, i) =>
//         <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { backgroundColor: 'yellow' } : {}}>
//             {part}
//         </span>)
//     } </span>;
// }
import convert from "xml-js";
import { ToWords } from "to-words";

const colors = ['var(--yellow)', 'var(--yellow)', 'var(--yellow)', 'var(--yellow)'];

const getHighlightedText = (text, highlight) => {
    if (text === null || text === undefined) return
    if (typeof text !== 'string') return text
    if (!highlight) return text
    const highlights = highlight?.trim()?.split(/\s+/);

    if (!highlights || highlights.length === 0) return <span>{text}</span>; // Return original text if no highlights

    const highlightsWithColor = highlights.map((text, i) => ({ text, color: colors[i] }));
    let parts = [{ value: text, isHighlighted: false }]; // Start with the entire text as one unhighlighted part

    highlights.forEach(highlight => {
        const newParts = [];
        const highlightRegex = new RegExp(`(${highlight})`, 'gi');

        parts.forEach(part => {
            if (part.isHighlighted) {
                // If it's already highlighted, just add it to newParts
                newParts.push(part);
            } else {
                // If not highlighted, split it by the current highlight term
                const splitResult = part?.value?.split(highlightRegex);
                splitResult.forEach(subPart => {
                    //  console.log({ subPart, highlight })
                    if (subPart.trim().replace('"', '').toLowerCase() === highlight.trim().toLowerCase()) {
                        newParts.push({ value: subPart, isHighlighted: true });
                    } else if (subPart) { // Ensure subPart is not empty
                        newParts.push({ value: subPart, isHighlighted: false });
                    }
                });
            }
        });
        parts = newParts; // Update parts for the next iteration
    });

    return (
        <span
        // style={{
        //     fontWeight: parts?.map(p => p.value).join('')?.includes('"') ? 600 : 500
        // }}
        >
            {parts.map((part, i) => (
                <span
                    key={i}
                    style={part.isHighlighted ? {
                        backgroundColor: 'var(--yellow)',

                        //  highlightsWithColor.find(hc => hc.text === part.value)?.color
                    } : {}}
                >
                    {part.value}
                </span>
            ))}
        </span>
    );
};


function findQuotedWordsAndPrecedingCode(sentence) {
    if (!sentence) return
    // Regex:
    // (\\S*)            -> Capturing group 1: Zero or more non-whitespace characters (the "code")
    // "                 -> Matches the literal opening double quote
    // ([^"]*)           -> Capturing group 2: Zero or more characters that are not a double quote (the "word")
    // "                 -> Matches the literal closing double quote
    const regex = /(\S*)\s"([^"]*)"/g;
    let results = [];
    let match;

    while ((match = regex.exec(sentence)) !== null) {
        results.push({
            precedingCode: match[1] === ',' ? results.at(-1)?.precedingCode : match[1], // The content of the first capturing group
            quotedWord: match[2]     // The content of the second capturing group
        });
    }

    return results;
}



function removeUndefinedValues(obj) {
    // console.log({ obj })
    return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined) //.map(([_, value]) => value.trim())
    );
}

function getAlphabetIndex(char) {
    // Convert the character to lowercase to handle both cases
    const lowerChar = char.toLowerCase();

    // Check if the character is a lowercase alphabet letter
    if (lowerChar >= 'a' && lowerChar <= 'z') {
        // Subtract 96 to get the 1-based index (a=1, b=2, etc.)
        return lowerChar.charCodeAt(0) - 96;
    } else {
        // Return -1 or throw an error for non-alphabetic characters
        return -1;
    }
}

function humanizeTimeDifference(isoString) {
    const dateObject = new Date(isoString);
    const now = new Date();
    const ms = now.getTime() - dateObject.getTime();
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
}

function customStringify(obj, order) {
    let jsonString = '{';
    const parts = [];
    for (const key of order) {
        if (obj.hasOwnProperty(key)) {
            parts.push(`"${key}":${JSON.stringify(obj[key])}`);
        }
    }
    jsonString += parts.join(',');
    jsonString += '}';
    return jsonString;
}

function camelCaseToWords(s) {
    const result = String(s ?? '')
        .replace(/([a-z\d])([A-Z])/g, '$1 $2')
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        .replace(/\bId\b/g, 'ID');
    return result.charAt(0).toUpperCase() + result.slice(1);
}

function highlightBoldText(text) {
    if (!text) return
    const parts = text.split(/"([^"]*)"/g); // Split by double quotes, capturing the content within
    const formattedText = parts.map((part, index) => {
        // Check if the part is the content that was inside double quotes
        if (index % 2 === 1) { // Odd indices hold the captured content
            return `<b>"${part}"</b>`; // Wrap it in a bold tag
        }
        return part;
    }).join(''); // Join the parts back into a string

    return <div dangerouslySetInnerHTML={{ __html: formattedText }} />; // Render as HTML
}

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

const sortByKeys = (unorderedObject) => {
    const sortedKeys = Object.keys(unorderedObject).sort(); // ['a', 'b', 'c']

    // 2. Create a new object with sorted keys
    const orderedObject = sortedKeys.reduce((obj, key) => {
        obj[key] = unorderedObject[key];
        return obj;
    }, {});

    return orderedObject
}

function formatTimeDifference(timeDifferenceMs) {
    const MS_PER_SECOND = 1000;
    const MS_PER_MINUTE = 60 * MS_PER_SECOND; // 60,000
    const MS_PER_HOUR = 60 * MS_PER_MINUTE;   // 3,600,000

    if (timeDifferenceMs >= MS_PER_HOUR) {
        const hours = timeDifferenceMs / MS_PER_HOUR;
        return `${hours.toFixed(1)} hours`;
    } else if (timeDifferenceMs >= MS_PER_MINUTE) {
        const minutes = timeDifferenceMs / MS_PER_MINUTE;
        return `${minutes.toFixed(1)} minutes`;
    } else {
        const seconds = timeDifferenceMs / MS_PER_SECOND;
        return `${seconds.toFixed(1)} seconds`;
    }
}

const getTimeDiff = ({ date1, date2 }) => {
    const timeDifferenceMs = Math.abs(date2.getTime() - date1.getTime());
    return formatTimeDifference(timeDifferenceMs)
}

const converXmlToJson = (xml) => {
    const options = { ignoreComment: true, alwaysChildren: true };
    const result = convert.xml2js(xml, options);
    //  console.log(result);
    return result;
};

const convertJsonToXml = (obj) => {
    if (!obj) return;
    const options = { compact: true, ignoreComment: true, spaces: 4 };
    const result = convert.json2xml(obj, options);
    //   console.log(result);
    return result;
};

const downloadTxtFile = (textToSave, fileName) => {
    const blob = new Blob([textToSave], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const convertDate = (date, format) => {
    if (!date) return;
    const d = new Date(date);

    const map = {
        YYYY: d.getUTCFullYear(),
        MM: String(d.getUTCMonth() + 1).padStart(2, "0"),
        DD: String(d.getUTCDate()).padStart(2, "0"),
        HH: String(d.getUTCHours()).padStart(2, "0"),
        mm: String(d.getUTCMinutes()).padStart(2, "0"),
        ss: String(d.getUTCSeconds()).padStart(2, "0"),
    };

    return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (matched) => map[matched]);
};

const toWords = new ToWords({
    localeCode: "en-US",
    converterOptions: {
        currency: true,
        ignoreDecimal: false,
        ignoreZeroCurrency: true,
        doNotAddOnly: false,
        currencyOptions: {
            // can be used to override defaults for the selected locale
            name: "Dollar",
            plural: "Dollars",
            symbol: "$",
            fractionalUnit: {
                name: "cent",
                plural: "cents",
                symbol: "",
            },
        },
    },
});

function getStartOfLastMonth() {
    const date = new Date();
    date.setDate(1);          // Set to the first day of the current month
    date.setMonth(date.getMonth() - 1); // Subtract one month
    date.setHours(0, 0, 0, 0); // Set time to midnight (start of the day)
    return date;
}
function getEndOfLastMonth() {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 0)
}

export {
    removeUndefinedValues,
    getHighlightedText,
    findQuotedWordsAndPrecedingCode,
    getAlphabetIndex,
    humanizeTimeDifference,
    customStringify,
    camelCaseToWords,
    highlightBoldText,
    delay,
    sortByKeys,
    getTimeDiff,
    converXmlToJson,
    convertJsonToXml,
    downloadTxtFile,
    convertDate,
    toWords,
    getStartOfLastMonth,
    getEndOfLastMonth
}